import {
    CLEAR_SELECTED_IMPROVEMENTS,
    SET_DEFAULT_SELECTED_IMPROVEMENTS,
    UPDATE_SELECTED_IMPROVEMENT
} from './selected-improvements-actions';

const initialState = {};

/**
 * Participation Student - Selected Improvements Reducer
 * Contains current state of what improvement calculation type user has selected per topic table
 *
 * Consumes CLEAR_SELECTED_IMPROVEMENTS action
 * Consumes SET_DEFAULT_SELECTED_IMPROVEMENTS action
 * Consumes UPDATE_SELECTED_IMPROVEMENT action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case CLEAR_SELECTED_IMPROVEMENTS:
            return initialState;

        case SET_DEFAULT_SELECTED_IMPROVEMENTS:
            return action.payload;

        case UPDATE_SELECTED_IMPROVEMENT: {
            const { topicId, selectedImprovement } = action.payload;
            return {
                ...state,
                [topicId]: selectedImprovement
            };
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/participation/student/selected-improvements-reducer.js